"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var rxjs_1 = require("rxjs"),
    ConnectivityResponse_1 = require("../model/ConnectivityResponse");

require("abortcontroller-polyfill/dist/abortcontroller-polyfill-only");

var Connectivity = function () {
  function t(t, e, n) {
    void 0 === e && (e = 1e3), void 0 === n && (n = !0), this.subject = new rxjs_1.ReplaySubject(1), this.url = "/ping", this.interval = 1e3, this.timeoutInterval = 3e4, this.lastConnectivityResponse = null, this.currentConnectivityResponse = null, this.onlyChange = !0, this.isFetchActive = !1, this.sdk = t, this.interval = e, this.onlyChange = n;
  }

  return t.prototype.singleCheck = function () {
    this.check();
  }, t.prototype.startCheck = function () {
    var t = this;
    this.check(), this.connectionIntervalHandler = setInterval(function () {
      t.check();
    }, this.interval);
  }, t.prototype.stopCheck = function () {
    clearInterval(this.connectionIntervalHandler);
  }, t.prototype.isOnline = function () {
    return this.currentConnectivityResponse.status !== ConnectivityResponse_1.ConnectivityStatus.offline;
  }, t.prototype.getServerUrl = function () {
    return this.sdk.getServerUrl() + this.url;
  }, t.prototype.check = function () {
    var n = this;

    if (!this.isFetchActive) {
      this.isFetchActive = !0;
      var t = new AbortController(),
          e = t.signal;
      this.timeoutIntervalHandler = setTimeout(function () {
        t.abort();
      }, this.timeoutInterval);
      var i = Date.now();
      fetch(this.getServerUrl(), {
        signal: e
      }).then(function (t) {
        var e = Date.now() - i;
        n.notify(e), n.reset();
      }).catch(function (t) {
        n.notify(), n.reset();
      });
    }
  }, t.prototype.reset = function () {
    clearTimeout(this.timeoutIntervalHandler), this.isFetchActive = !1;
  }, t.prototype.notify = function (t) {
    void 0 === t && (t = -1), this.currentConnectivityResponse = new ConnectivityResponse_1.ConnectivityResponse(t), this.onlyChange && this.lastConnectivityResponse && this.currentConnectivityResponse ? this.lastConnectivityResponse.status !== this.currentConnectivityResponse.status && this.subject.next(this.currentConnectivityResponse) : this.subject.next(this.currentConnectivityResponse), this.lastConnectivityResponse = this.currentConnectivityResponse;
  }, t;
}();

exports.Connectivity = Connectivity;